import ElementQueries from "css-element-queries/src/ElementQueries";

ElementQueries.listen();
ElementQueries.init();

window.updateElementQueries = () => {
  ElementQueries.init(); // it's ok to call it multiple times.
};
